import { parseError, useSubmitProps } from "core/shared";
import { action } from "framework/config/action";
import { URLS } from "framework/config/urls";

export function useAddAddress({ onSuccess, onError }: useSubmitProps) {
  const submit = action(URLS.account.address);

  const addAddressSubmit = async ({ values, form }) => {
    if (values.isOther) {
      delete values.city;
    }

    const response = await submit({
      ...values,
      action: "add",
    });
    form.submitting(false);

    if (response.isOK) {
      onSuccess?.(response.data);
    } else {
      onError?.(parseError(response));
    }
  };

  return { addAddressSubmit };
}

export function useUpdateAddress(
  addressId: number,
  { onSuccess, onError }: useSubmitProps,
) {
  if (!addressId) {
    return {};
  }

  const submit = action(URLS.account.address);

  const updateAddressSubmit = async ({ values, form }) => {
    if (values.isOther) {
      delete values.city;
    }

    const response = await submit({
      ...values,
      action: "edit",
      addressId,
    });
    form.submitting(false);

    if (response.isOK) {
      onSuccess?.(response.data);
    } else {
      onError?.(parseError(response));
    }
  };

  return { updateAddressSubmit };
}

export function useSetPrimaryAddress(
  addressId: number,
  { onSuccess, onError }: useSubmitProps,
) {
  const submit = action(URLS.account.address);

  const setPrimaryAddress = async () => {
    const response = await submit({ addressId, action: "set-primary" });

    if (response.isOK) {
      onSuccess?.(response.data);
    } else {
      onError?.(parseError(response));
    }
  };

  return { setPrimaryAddress };
}

export function useDeleteAddress(
  addressId: number,
  { onSuccess, onError }: useSubmitProps,
) {
  const submit = action(URLS.account.address);

  const deleteAddressSubmit = async () => {
    const response = await submit({ addressId, action: "delete" });

    if (response.isOK) {
      onSuccess?.(response.data);
    } else {
      onError?.(parseError(response));
    }
  };

  return { deleteAddressSubmit };
}
